export default __webpack_public_path__ + "images/user-password.png?8c042cc22527e632aeb73c2b7a3883b4";